import $ from 'jquery';
// import SalmonRivers from './salmon-rivers';

class Tabs {
  init() {
    this.tabs = $('.js-tabs');

    if (!this.tabs.length) {
      return;
    }

    this.tabsToggle();
  }

  tabsToggle() {
    this.tabs.each((index, element) => {
      const tabs = $(element);
      const tabsNav = tabs.find('.js-tabs-nav');
      const tabsContent = tabs.find('.js-tabs-content');
      const links = tabsNav.find('.js-tabs-nav-link');
      const contentPanes = tabsContent.find('.js-tabs-content-pane');
      const noAnim = tabsNav.data('no-anim');
      const animationSpeed = noAnim === true ? 0 : 300;

      tabsNav.on('click', '.js-tabs-nav-link', e => {
        e.preventDefault();
        const link = $(e.currentTarget);

        if (link.hasClass('is-active')) {
          return;
        }

        const target = link.attr('href');
        const contentPane = tabsContent.find(`${target}`);

        if (contentPane.length) {
          links
            .not(link)
            .removeClass('is-active')
            .attr('aria-current', false);
          link.addClass('is-active').attr('aria-current', true);

          this.wwfInfoHeading();

          tabsContent.stop().animate({ opacity: 0 }, animationSpeed, () => {
            contentPanes.not(contentPane).removeClass('is-active');
            contentPane.addClass('is-active');
            tabsContent.stop().animate({ opacity: 1 }, animationSpeed);
          });
        }
      });
    });
  }

  wwfInfoHeading() {
    if (!$('.js-river-wwf-info').length) {
      return;
    }

    const content = $('.js-bsrs-content');
    this.wwfInfo = content.find('.js-river-wwf-info');
    const riverHeading = $('.js-river-heading');

    const infoHeading = this.wwfInfo.find('.js-river-wwf-info-heading');

    if (infoHeading.length) {
      infoHeading.remove();
    }

    if (this.wwfInfo.length) {
      const wwfInfoNameText = this.wwfInfo
        .parent()
        .find('.js-tabs-nav-link.is-active')
        .text();
      const wwfInfoName = wwfInfoNameText.match(/(steelhead)/i)
        ? wwfInfoNameText
        : `${wwfInfoNameText} Salmon`;
      const wwfInfoHeadingText = `${wwfInfoName} in ${riverHeading.text()}`;
      this.wwfInfo.prepend(
        `<h4 class="c-river-wwf-info-heading js-river-wwf-info-heading">${wwfInfoHeadingText}</h4>`,
      );
    }
  }

  // wwfInfoHeading(tabsNav) {
  //   if (tabsNav.siblings('.js-river-wwf-info').length) {
  //     this.river = new SalmonRivers();
  //     this.river.wwfInfoHeading();
  //   }
  // }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/scripts/modules/tabs.js